import React from "react";
import { History } from "lucide-react";
import { Card } from "@shared/ui/card";
import { PageHeader } from "@shared/components/PageHeader";
import { useParams } from "react-router-dom";
import { useVersionHistory } from "../../../hooks";

const VersionHistory = () => {
  const params = useParams();
  const templateId = params.id;

 const { data: versionHistoryData } = useVersionHistory(templateId);
 const versions = versionHistoryData?.versions ?? [];
  return (
    <Card className="p-6">
      <div>
        <PageHeader
          title="Version History"
          subtitle="Manage versions for this template"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-2">
        {versions.map((version) => (
          <div
            key={version.id}
            className="border border-gray-200 rounded-lg p-4 hover:border-gray-300 hover:shadow-sm transition-all cursor-pointer bg-white"
          >
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-1">
                <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                  <History className="w-5 h-5 text-blue-600" />
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-gray-900">
                    Version {version.version}
                  </h3>

                  {version.isCurrent && (
                    <span className="px-2 py-0.5 text-xs font-medium bg-blue-600 text-white rounded">
                      Current
                    </span>
                  )}
                </div>

                <div className="text-xs text-gray-600 mb-3">
                  Updated by {version.lastModifiedBy} • {version.lastModifiedDate}
                </div>

                <div className="text-xs text-gray-500 italic">
                  {version.changesSummary}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default VersionHistory;
